<div class="flex h-screen overflow-hidden bg-[#F0F5F9] dark:bg-slate-900 relative">
    <!-- Sidebar -->
    <div class="fixed rounded-2xl lg:mb-4 mt-0 lg:mt-4 ml-0 lg:ml-4 z-30 inset-y-0 left-0 
    transform bg-[#FFFFFF] dark:bg-slate-800 transition-[width,transform] duration-300 cubic-bezier(0.4, 0, 0.2, 1) shadow-2xl will-change-transform"
        [class.-translate-x-full]="isOver() && !sidenavOpened()" [class.w-64]="!sidenavCollapsed() && !isOver()"
        [class.w-20]="sidenavCollapsed() && !isOver()" [class.w-70]="isOver()" [class.rounded-none]="isOver()">
        <div class="flex flex-col h-full flex-layout">
            <app-admin-sidebar (toggleMobileNav)="toggleCollapsed()" [showToggle]="isOver()"
                [collapsed]="sidenavCollapsed()"></app-admin-sidebar>

            <div class="flex-1 overflow-y-auto nav-content-scroll">
                <div class="sidebar-list py-2">
                    @for (group of groupedMenu(); track group.key; let first = $first) {
                    @if (!first && sidenavCollapsed()) {
                    <div class="mx-7 my-2 h-[1px] bg-gray-300 dark:bg-slate-600"></div>
                    }
                    @if (group.label && !sidenavCollapsed()) {
                    <div
                        class="nav-subheader text-[10px] font-black text-slate-800 dark:text-primary px-4 mt-4 mb-2 uppercase tracking-[0.12em] opacity-80">
                        {{ group.label }}
                    </div>
                    }
                    @for (item of group.items; track item.label) {
                    <app-nav-item [item]="item" (notify)="sidenavOpened.set(false)"
                        [isCollapsed]="sidenavCollapsed()"></app-nav-item>
                    }
                    }
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Overlay -->
    @if (isOver() && sidenavOpened()) {
    <div class="fixed inset-0 bg-slate-900/50 z-20 lg:hidden transition-opacity duration-300"
        (click)="toggleCollapsed()"></div>
    }

    <!-- Main content container -->
    <div class="flex flex-col flex-1 overflow-hidden transition-[margin-left] duration-300 cubic-bezier(0.4, 0, 0.2, 1) will-change-[margin-left]"
        [ngClass]="sidenavCollapsed() ? 'ml-0 lg:ml-25' : 'ml-0 lg:ml-67'">
        <app-admin-navbar [isMobileOver]="isOver()" [sidenavCollapsed]="sidenavCollapsed()"
            (toggleMobileNav)="sidenavOpened.set(!sidenavOpened())"
            (toggleSidebarCollapseEvent)="toggleSidebarCollapse()"
            (logout)="showLogoutDialog = true"></app-admin-navbar>

        <main
            class="flex flex-col flex-1 w-full items-center overflow-y-auto overflow-x-hidden bg-[#F0F5F9] dark:bg-slate-900 relative"
            id="layout-content">
            <div class="w-full px-4 max-w-[1800px] flex-1">
                @if (!isBlocked() || isMembershipPage() || isSuperAdmin()) {
                <router-outlet class="w-full"></router-outlet>
                } @else {
                <!-- Card de Bloqueo -->
                <div
                    class="flex flex-col items-center justify-center min-h-[70vh] text-center p-6 bg-white dark:bg-slate-800 rounded-3xl shadow-xl mt-8">
                    <div
                        class="bg-white rounded-[2.5rem] p-10 shadow-2xl border border-slate-100 max-w-lg w-full text-center relative overflow-hidden">
                        <div class="absolute top-0 right-0 p-4 opacity-5">
                            <span class="iconify text-8xl"
                                [attr.data-icon]="isNoPlan() ? 'solar:magic-stick-bold' : 'solar:shield-warning-bold'"></span>
                        </div>

                        <div
                            class="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-8 text-primary shadow-inner">
                            <span class="iconify text-4xl"
                                [attr.data-icon]="isNoPlan() ? 'solar:confetti-bold' : 'solar:lock-bold'"></span>
                        </div>

                        <h2 class="text-3xl font-black text-slate-800 uppercase tracking-tight mb-4 leading-tight">
                            {{ isNoPlan() ? '¡Bienvenido a DENTIUM SYS!' : 'Sistema Bloqueado' }}
                        </h2>

                        <p class="text-slate-500 font-bold leading-relaxed mb-8 px-4 text-sm">
                            {{ isNoPlan() ?
                            `Estamos felices de tenerte aquí. Para comenzar a disfrutar de todas
                            nuestras funciones, por favor adquiere un plan.` : `Tu membresía ha superado el periodo de
                            gracia y el sistema ha sido suspendido. Por favor, realiza el pago para reactivar todas las
                            funciones.` }}
                        </p>

                        <div class="space-y-3">
                            <button [routerLink]="['/app/membership']"
                                class="w-full py-4 bg-primary hover:bg-primary/90 text-white rounded-2xl text-xs font-black uppercase tracking-widest shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 active:scale-95">
                                <span class="iconify text-lg"
                                    [attr.data-icon]="isNoPlan() ? 'solar:cart-large-4-bold' : 'solar:card-send-bold'"></span>
                                {{ isNoPlan() ? 'Adquirir mi primer plan' : 'Renovar membresía' }}
                            </button>
                            <button (click)="confirmLogout()"
                                class="w-full py-4 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-slate-200 dark:hover:bg-slate-600 transition-all flex items-center justify-center gap-2 active:scale-95">
                                <iconify-icon icon="solar:logout-3-bold" class="text-lg"></iconify-icon>
                                Cerrar Sesión
                            </button>
                        </div>
                    </div>
                </div>
                }
            </div>

            <footer class="text-center text-sm text-gray-500 py-4">
                <p class="text-gray-400 text-xs font-medium uppercase tracking-widest">
                    &copy; {{ currentYear }} &middot; DENTIUM SYS
                </p>
            </footer>
        </main>


    </div>

    <!-- Dialog de Confirmación de Logout Global -->
    <app-confirm-dialog [visible]="showLogoutDialog" type="logout" title="¿Cerrar sesión?"
        message="¿Estás seguro de que deseas cerrar tu sesión?" confirmLabel="Cerrar Sesión" cancelLabel="Cancelar"
        (confirm)="confirmLogout()" (cancel)="showLogoutDialog = false">
    </app-confirm-dialog>

    <app-dialog></app-dialog>

</div>